module.exports = __webpack_public_path__ + "img/money.36e2cfe3.svg";